import Box from '@material-ui/core/Box';
import { getStyle } from 'globalutils/fmUtils';
import styled from 'styled-components';

const ExportWrapper = styled(Box)`
  ${({ theme, style, transition }) => `

  .exportClose {
    position: absolute;
    width: 19px;
    height: 19px;
    top: 6px;
    right: 10px;
    display: flex;
    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
  border: 1.5px solid #2C3249;
  background-color: ${
    (getStyle((style || {}).border, theme.palette.primary || {}).main,
    theme.colors.PRIMARY_MAIN)
  };
  padding: 5px;
  padding-top: 11px;
  width: 430px;
  z-index: 10;
  display: -webkit-box;   /* OLD - iOS 6-, Safari 3.1-6, BB7 */
  display: -ms-flexbox;  /* TWEENER - IE 10 */
  display: -webkit-flexbox;
  display: flex; 
  justify-content: flex-end;
  flex-direction: column;
  position: absolute;
  right: ${({ right }) => right || '30px'};
  @media (max-width: ${theme.breakpoints.values.sm}px) {
    width: 240px;
    form {
      flex-direction: column;
      #button {
        margin-top: 2px;
      }
    }
  }
  animation: ${transition || 'fromRight'}
    1.5s forwards ease-in-out;
  @keyframes fromRight {
    from {
      right: -450px;
    }
    to {
      right: 3px;
    }
  }
  .bulkSection {
    padding: 2%;
    padding-top: 3%;
    justify-content: flex-start;
    .vertical {
      flex: 0 0 48%;
    }
    .vertical-button {
      justify-content: center;
      display: flex;
      width: 100%;
      .MuiBox-root {
        width: 30% !important;
      }
      .MuiButtonBase-root {
        margin-top: -14px;
      }
    }
  }
  form .vertical {
    flex: 0 0 38%;
    margin-right: 1%;
  }
  .vertical-button {
    width: 20%;
    button {
      min-width: 50px !important;
    }
    .MuiButtonBase-root {
      margin-top: 32px;
    }
  }
  .vertical-button .MuiBox-root {
    width: 100% !important;
    margin-right: 0px !important;
  }
  .react-datepicker-wrapper input,
  .react-datepicker-wrapper {
    height: 35px !important;
    padding-left: 4px !important;
    min-height: auto;
    border-color: ${theme.colors.INPUT_BORDER} !important;
  }
  @keyframes toRight {
    from {
      right: 3px;
    }
    to {
      right: -500px;
    }
  }
  .MuiButtonBase-root {
    height: 35px !important;
    font-size: 12px;
    margin-top: 21px;
  }
  .MuiButton-label {
    height: 35px !important;
  }
  .react-datepicker__day--today {
    color:  ${theme.colors.SECONDARY_MAIN} !important;
  }
  `}
`;

const Header = styled(Box)`
  display: -webkit-box;   /* OLD - iOS 6-, Safari 3.1-6, BB7 */
display: -ms-flexbox;  /* TWEENER - IE 10 */
display: -webkit-flexbox;
display: flex; 
`;

const Styled = { ExportWrapper, Header };

export default Styled;
